/** @ignore *//** */

/** @hidden */
interface UserInterface {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  emailVerified: boolean;
  added: Date | null;
  updated: Date | null;
}

/** @hidden */
export default class User implements UserInterface {
  /*
  constructor (id: string) {
    this.id = id;
  }
  */
  id = '';
  email = '';
  firstName = '';
  lastName = '';
  emailVerified = false;
  added = null;
  updated = null;
}